import React from "react";
import Hero from "./Components/Hero";
import Navbar from "./Components/Navbar";
import Nosotros from "./Components/About";
import Contact from './Components/Contact';
import Services from "./Components/Services";
import Footer from "./Components/Footer";
import CarouselLogo from "./Components/CarouselLogo";
import WhatsappButton from "./Components/WhatsappButton";
import TrustedCompanies from "./Components/TrustedCompanies";


function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <CarouselLogo/>
      <Services />
      <TrustedCompanies />
      <Nosotros />
      <Contact />
      <Footer />
      <WhatsappButton/>
    </>
  );
}

export default App;
